import Divider from '@rio-cloud/rio-uikit/components/divider/Divider';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { Fragment } from 'react/jsx-runtime';
import { useIntl } from 'react-intl';

import ThreadListItem from '@/components/organism/ThreadListItem/ThreadListItem';

import { ImgSrc, StyledListItem } from './Style';
import { TThreadsInTimespanListProps } from './types';

/** Splits a given list of thrads into specific timespans(today, last 7days, last 30days and older) */
const ThreadsInTimespanList = ({ title, threads, searchWord, isLoading }: TThreadsInTimespanListProps) => {
  const intl = useIntl();

  if (isLoading) {
    return (
      <div className="display-flex justify-content-center align-items-center padding-50">
        <Spinner isDoubleSized />
      </div>
    );
  }

  return (
    <div>
      {title ? (
        <Fragment>
          <Divider spacing={5} className="padding-0" />
          <StyledListItem>
            <ImgSrc className="rioglyph rioglyph-calendar" />
            <p className="text-medium">{intl.formatMessage({ id: title })}</p>
          </StyledListItem>
        </Fragment>
      ) : null}
      <Divider spacing={5} className="padding-0" />
      <ul className="overflow-auto list-group padding-0" data-testid="thread-history-list">
        {threads.map((thread, index) =>
          thread.title ? (
            <ThreadListItem
              index={index}
              key={`item-${thread.threadId}`}
              threadId={thread.threadId}
              firstMessage={thread.title}
              isFavorite={thread.isFavorite}
              searchWord={searchWord}
            />
          ) : null,
        )}
      </ul>
    </div>
  );
};

export default ThreadsInTimespanList;
